import _uniqueId from 'lodash/uniqueId';
import { ReactNode, useState } from 'react';
import styles from './input.module.css';
import { ReactComponent as ViewIcon } from './assets/view.svg';
import { ReactComponent as EditIcon } from './assets/edit.svg';

interface InputProps {
  type: string;
  value?: string | undefined;
  // eslint-disable-next-line react/require-default-props
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  onEdit?: () => void;
  label: string;
  name: string;
  placeholder?: string;
  optional?: boolean;
  readOnly?: boolean;
  autoComplete?: string;
  autoFocus?: boolean;
}

const Input: React.FC<InputProps> = ({
  type,
  value,
  onChange,
  onEdit,
  label,
  name,
  placeholder,
  optional,
  readOnly,
  autoComplete,
  autoFocus = false,
}: InputProps) => {
  const [id] = useState(_uniqueId(`${name}-`));
  const [currentType, setCurrentType] = useState(type);
  const [active, setActive] = useState(false);

  function switchType() {
    if (currentType === 'password') {
      setCurrentType('text');
    } else {
      setCurrentType('password');
    }
  }

  function onFocus() {
    if (!readOnly) {
      setActive(true);
    }
  }
  function onBlur() {
    setActive(false);
  }

  return (
    <div
      className={`${styles.input} ${
        readOnly ? styles['input--readonly'] : ''
      } ${active ? styles['input--active'] : ''}`}
    >
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <input
        type={currentType}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        name={name}
        className={styles.field}
        required={!optional}
        disabled={readOnly}
        id={id}
        autoComplete={autoComplete}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
      />
      {type === 'password' && (
        <button
          type="button"
          onClick={switchType}
          aria-labelledby={`button-label-${id}`}
          className={styles.viewButton}
        >
          <span id={`button-label-${id}`} hidden>
            Onthul
          </span>
          <ViewIcon />
        </button>
      )}
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          aria-labelledby={`button-label-${id}`}
          className={styles.viewButton}
        >
          <span id={`button-label-${id}`} hidden>
            Bewerk
          </span>
          <EditIcon />
        </button>
      )}
    </div>
  );
};

interface InputGroupProps {
  children: ReactNode;
}

export const InputGroup: React.FC<InputGroupProps> = ({
  children,
}: InputGroupProps) => {
  return <div className={styles.group}>{children}</div>;
};

export default Input;
